export type FormDrawerType = 'book' | 'prescription'

// Links pointing to one of these hashes open the form drawer on that form (see TheFormDrawer)
export const FORM_DRAWER_HASHES: Record<string, FormDrawerType> = {
  '#book-now-drawer': 'book',
  '#prescription-drawer': 'prescription',
}

export const useFormDrawer = () => useState<FormDrawerType | null>('formDrawer', () => null)
